import { createFileRoute } from '@tanstack/react-router';

import { CONVERSATION_PAGE_ANCHOR } from '@/features/(insight)/conversation/constants';
import { ConversationPage } from '@/features/(insight)/conversation/index';
import z from 'zod';

export const Route = createFileRoute('/workspace/$workspaceId/insight/conversation')({
  validateSearch: z.object({
    anchor: z
      .enum([
        CONVERSATION_PAGE_ANCHOR.BRANDS_PRODUCTS_SECTION,
        CONVERSATION_PAGE_ANCHOR.NEGATIVE_THEME_SECTION,
        CONVERSATION_PAGE_ANCHOR.POSITIVE_THEME_SECTION,
        CONVERSATION_PAGE_ANCHOR.WORD_CLOUD_SECTION,
      ])
      .optional(),
  }),
  component: ConversationPage,
});
